import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/api";

export default function WhatsAppButton() {
  return (
    <a
      data-testid="whatsapp-floating-support-button"
      href={waLink("Hi Rent-ya-Buy! I need help finding a property.")}
      target="_blank"
      rel="noreferrer"
      title="Need Help? Chat with Property Expert on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500 text-white shadow-lg shadow-emerald-500/30 transition-transform duration-300 hover:scale-110 hover:bg-emerald-600"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
}
